export const STORE_DATA_SCOPE_KEY = 'crm_store_data_scope';
export const STORE_DATA_SCOPE_EVENT = 'store-data-scope:changed';

export type StoreDataScopeMode = 'all' | 'store';

export type StoreDataScope = {
  mode: StoreDataScopeMode;
  companyId?: string | null;
  storeId?: string | null;
};

function normalizeMode(value: unknown): StoreDataScopeMode {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === 'store') return 'store';
  return 'all';
}

export function normalizeStoreDataScope(value: unknown): StoreDataScope {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return { mode: 'all' };
  }

  const raw = value as StoreDataScope;
  const mode = normalizeMode(raw.mode);
  const companyId = String(raw.companyId || '').trim() || null;
  const storeId = String(raw.storeId || '').trim() || null;

  if (mode !== 'store' || !companyId || !storeId) {
    return { mode: 'all' };
  }

  return {
    mode: 'store',
    companyId,
    storeId
  };
}

export function getStoredStoreDataScope(): StoreDataScope {
  if (typeof window === 'undefined') {
    return { mode: 'all' };
  }

  const raw = window.localStorage.getItem(STORE_DATA_SCOPE_KEY);
  if (!raw) {
    return { mode: 'all' };
  }

  try {
    return normalizeStoreDataScope(JSON.parse(raw));
  } catch {
    return { mode: 'all' };
  }
}

export function setStoredStoreDataScope(nextScope: StoreDataScope) {
  if (typeof window === 'undefined') {
    return;
  }

  const normalized = normalizeStoreDataScope(nextScope);
  window.localStorage.setItem(STORE_DATA_SCOPE_KEY, JSON.stringify(normalized));
  window.dispatchEvent(new CustomEvent(STORE_DATA_SCOPE_EVENT, {
    detail: normalized
  }));
}

export function clearStoredStoreDataScope() {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(STORE_DATA_SCOPE_KEY);
  window.dispatchEvent(new CustomEvent(STORE_DATA_SCOPE_EVENT, {
    detail: { mode: 'all' }
  }));
}
